import { hasAccessToDirectMarketing, useAccessLuoxDynamicTariff } from 'src/Libs/installation-extensions'
import { FeatureElements } from '../feature-versioning'
import { useUser } from 'src/Hooks/useUser'
import { useTypedSelector } from 'src/State/RootReducer'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { isFlowTheme } from 'src/Libs/utils'

interface ReturnType {
  featureElements: FeatureElements[]
}

/**
 * This hook provides the elements that should be considered to evaluate if the "more" bottom bar item should be labeled as new
 */
const useFeatureElementsForMoreBottomBar = (): ReturnType => {
  const { userData } = useUser()
  const currentInstallation = useTypedSelector(state => state.storage.installation)
  const shopAccess = useTypedSelector(state => state.shop.shopAccess)
  const {
    featureFlags: { isCustomerReferralEnabled, isReonicEnabled, isExtensionsPageVisibleInFlow },
  } = useFeatureFlagsContext()
  const featureElements: FeatureElements[] = [FeatureElements.ContactSideBarElement]
  const isUserPartnerOrInstaller = userData?.level === 'INSTALLER' || userData?.level === 'PARTNER'
  const hasAccessLuoxDynamicTariff = useAccessLuoxDynamicTariff(currentInstallation, userData)
  const hasExtensionsPageAccess = (!isFlowTheme || isExtensionsPageVisibleInFlow) && hasAccessToDirectMarketing(currentInstallation, userData)

  if (isCustomerReferralEnabled) featureElements.push(FeatureElements.ReferFriendsSideBarElement)
  if (shopAccess) featureElements.push(FeatureElements.ShopSideBarElement)
  if (hasExtensionsPageAccess) featureElements.push(FeatureElements.ExtensionSideBarElement)
  if (hasAccessLuoxDynamicTariff) featureElements.push(FeatureElements.LuoxDynamicTariffExtensionElement)
  if (userData?.level === 'E3DC_SERVICE') featureElements.push(FeatureElements.MessageOfTheDaySideBarElement)
  featureElements.push(FeatureElements.RetrofitSidebarElement)
  if (isReonicEnabled && isUserPartnerOrInstaller) featureElements.push(FeatureElements.ReonicConfiguratorSidebarElement)

  return { featureElements }
}

export default useFeatureElementsForMoreBottomBar
